module.exports = __webpack_public_path__ + "static/media/Front-Of-Foot(R) v1.6a262b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front-Of-Foot(R) v1.jpg
// module id = 409
// module chunks = 0